import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const getHeaders = () => ({
  headers: {
    'x-api-key': localStorage.getItem('token'),
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

const BASE_LOOKUP_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/lookups`;

export const fetchLookups = createAsyncThunk(
  'lookups/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const [media, coreServices, coreInitiatives, events] = await Promise.all([
        axios.get(`${BASE_LOOKUP_URL}/media`, getHeaders()),
        axios.get(`${BASE_LOOKUP_URL}/core-services`, getHeaders()),
        axios.get(`${BASE_LOOKUP_URL}/core-initiatives`, getHeaders()),
        axios.get(`${BASE_LOOKUP_URL}/events`, getHeaders()),
      ]);

      return {
        media: media.data,
        coreServices: coreServices.data,
        coreInitiatives: coreInitiatives.data,
        events: events.data,
      };
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/admin/login';
        return rejectWithValue('UNAUTHORIZED');
      }

      return rejectWithValue(
        err.response?.data?.message || err.message || 'Lookup fetch failed'
      );
    }
  }
);


const lookupSlice = createSlice({
  name: 'lookups',
  initialState: {
    media: [],
    coreServices: [],
    coreInitiatives: [],
    events: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLookups.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLookups.fulfilled, (state, action) => {
        state.loading = false;
        state.media = action.payload.media;
        state.coreServices = action.payload.coreServices;
        state.coreInitiatives = action.payload.coreInitiatives;
        state.events = action.payload.events;
      })
      .addCase(fetchLookups.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;

        
      });
  },
});

export default lookupSlice.reducer;
